const RECORDS_KEY = "skolska_evidencija_dezuranja_v1";
const SETTINGS_KEY = "skolska_evidencija_postavke_v1";

export const defaultSettings = {
  nazivSkole: "",
  mjesto: "",
  ravnatelj: "",
  emailRavnatelja: "",
  opcije: {
    autobusi: true,
    smjene: false,
    podrucneSkole: false,
    dezurniUcenici: false,
  },
};

export function loadSettings() {
  try {
    const raw = localStorage.getItem(SETTINGS_KEY);
    if (!raw) return { ...defaultSettings };
    const parsed = JSON.parse(raw);
    return { ...defaultSettings, ...parsed, opcije: { ...defaultSettings.opcije, ...(parsed.opcije || {}) } };
  } catch {
    return { ...defaultSettings };
  }
}

export function saveSettings(s) {
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(s));
}

export function loadRecords() {
  try {
    const raw = localStorage.getItem(RECORDS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function saveRecord(record) {
  const records = loadRecords();
  const idx = records.findIndex((r) => r.id === record.id);
  const updated = { ...record, updatedAt: new Date().toISOString() };
  if (idx >= 0) records[idx] = updated;
  else records.push(updated);
  localStorage.setItem(RECORDS_KEY, JSON.stringify(records));
  return updated;
}

export function deleteRecord(id) {
  const records = loadRecords().filter((r) => r.id !== id);
  localStorage.setItem(RECORDS_KEY, JSON.stringify(records));
}

export function findTodayRecord(tip) {
  const today = new Date().toISOString().slice(0, 10);
  return loadRecords().find((r) => r.tip === tip && r.datum === today);
}

export function newRecord(tip) {
  return {
    id: `ev_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    tip,
    datum: new Date().toISOString().slice(0, 10),
    osnovni: {
      dezurnoOsoblje: "",
      glavniDezurni: "",
      dezurniPrizemlje: "",
      dezurniKat: "",
      dezurniMedjusmjena: "",
      razlogNenastavnog: "",
      smjena: "",
      podrucnaSkola: "",
      dezurniUcenici: "",
      napomena: "",
    },
    autobusi: { dolasci: "", odlasci: "" },
    posjetitelji: [],
    zapazanja: { steta: "", nasilje: "", otudjenje: "", nepoznateOsobe: "" },
    dogadjaji: [],
    pregled: { zakljucao: "", ravnateljPregledao: "", zapazanjaRavnatelja: "", zakljucano: false },
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
}

export function exampleRecord() {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  const datum = d.toISOString().slice(0, 10);
  const r = newRecord("nastavni");
  return {
    ...r,
    datum,
    primjer: true,
    osnovni: {
      ...r.osnovni,
      dezurnoOsoblje: "Ivana Horvat, prof. hrvatskog jezika\nMarko Kovačević, prof. matematike\nAna Babić, spremačica\nJosip Novak, domar",
      glavniDezurni: "Ivana Horvat, prof.",
      dezurniPrizemlje: "Marko Kovačević, prof. (glavni ulaz i hodnik)\nPetra Jurić, prof. (blagovaonica)",
      dezurniKat: "Ana Marić, prof. (hodnik prvog kata)\nTomislav Šarić, prof. (knjižnica i informatička učionica)",
      dezurniMedjusmjena: "Petra Jurić, prof. (12:30 do 13:30)",
      napomena: "Dežurstvo proteklo uredno. Tijekom velikog odmora pojačan nadzor u dvorištu zbog radova na ogradi.",
    },
    autobusi: {
      dolasci: "7:35 - linija Ivanovac, sve uredno\n7:50 - linija Orlovnjak, kašnjenje 5 minuta zbog magle\n8:00 - linija Antunovac centar, sve uredno",
      odlasci: "13:10 - linija Ivanovac, sve uredno\n13:15 - linija Orlovnjak, sve uredno\n14:05 - linija Antunovac centar, sve uredno",
    },
    posjetitelji: [
      { ime: "Maja Perić", dolazak: "9:15", odlazak: "9:45", isprava: "Osobna iskaznica", razlog: "Razgovor s razrednicom", osoba: "Ana Marić, prof." },
      { ime: "Damir Šimić (serviser)", dolazak: "10:30", odlazak: "12:00", isprava: "Službena iskaznica tvrtke", razlog: "Servis fotokopirnog uređaja", osoba: "Tajništvo" },
    ],
    zapazanja: {
      steta: "Uočena razbijena pločica na stubištu kod ulaza u dvoranu. Obaviješten domar, mjesto označeno i osigurano.",
      nasilje: "Manji verbalni sukob dvojice učenika 6. razreda za vrijeme velikog odmora. Razgovor obavila dežurna učiteljica, obaviješten razrednik.",
      otudjenje: "Nije zabilježeno otuđenje stvari.",
      nepoznateOsobe: "Nepoznata osoba zatečena u dvorištu oko 11:20. Utvrđeno da čeka dijete, zamoljena da čeka izvan školskog dvorišta.",
    },
    dogadjaji: [
      {
        datum,
        vrsta: "Lakša ozljeda učenika",
        opis: "Učenik 4. razreda pao je na satu tjelesnog i zadobio oguljotinu koljena.",
        mjere: "Pružena prva pomoć, obaviješteni roditelji i razrednica, upisano u evidenciju ozljeda.",
      },
    ],
    pregled: { ...r.pregled, zakljucao: "Ivana Horvat, prof." },
  };
}

export function exportAllJSON() {
  const data = { verzija: 1, izvezeno: new Date().toISOString(), postavke: loadSettings(), evidencije: loadRecords() };
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `evidencije-dezuranja-${new Date().toISOString().slice(0, 10)}.json`;
  a.click();
  URL.revokeObjectURL(url);
}

export function importJSON(text) {
  const data = JSON.parse(text);
  if (!data || !Array.isArray(data.evidencije)) throw new Error("Neispravan format datoteke");
  const existing = loadRecords();
  const map = new Map(existing.map((r) => [r.id, r]));
  data.evidencije.forEach((r) => map.set(r.id, r));
  localStorage.setItem(RECORDS_KEY, JSON.stringify([...map.values()]));
  if (data.postavke) saveSettings({ ...loadSettings(), ...data.postavke });
  return data.evidencije.length;
}

export function formatDatum(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}.${m}.${y}.`;
}
